export default [
    {
        name: 'Afrikaans',
        iso_639_code: 'af',
    },
    {
        name: 'Albanian',
        iso_639_code: 'sq',
    },
    {
        name: 'Amharic',
        iso_639_code: 'am',
    },
    {
        name: 'Arabic',
        iso_639_code: 'ar',
    },
    {
        name: 'Armenian',
        iso_639_code: 'hy',
    },
    {
        name: 'Azerbaijani',
        iso_639_code: 'az',
    },
    {
        name: 'Basque',
        iso_639_code: 'eu',
    },
    {
        name: 'Belarusian',
        iso_639_code: 'be',
    },
    {
        name: 'Bengali',
        iso_639_code: 'bn',
    },
    {
        name: 'Bosnian',
        iso_639_code: 'bs',
    },
    {
        name: 'Bulgarian',
        iso_639_code: 'bg',
    },
    {
        name: 'Catalan',
        iso_639_code: 'ca',
    },
    {
        name: 'Cebuano',
        iso_639_code: 'ceb',
    },
    {
        name: 'Chinese (Simplified)',
        iso_639_code: 'zh-CN',
    },
    {
        name: 'Chinese (Traditional)',
        iso_639_code: 'zh-TW',
    },
    {
        name: 'Corsican',
        iso_639_code: 'co',
    },
    {
        name: 'Croatian',
        iso_639_code: 'hr',
    },
    {
        name: 'Czech',
        iso_639_code: 'cs',
    },
    {
        name: 'Danish',
        iso_639_code: 'da',
    },
    {
        name: 'Dutch',
        iso_639_code: 'nl',
    },
    {
        name: 'English',
        iso_639_code: 'en',
    },
    {
        name: 'Esperanto',
        iso_639_code: 'eo',
    },
    {
        name: 'Estonian',
        iso_639_code: 'et',
    },
    {
        name: 'Finnish',
        iso_639_code: 'fi',
    },
    {
        name: 'French',
        iso_639_code: 'fr',
    },
    {
        name: 'Frisian',
        iso_639_code: 'fy',
    },
    {
        name: 'Galician',
        iso_639_code: 'gl',
    },
    {
        name: 'Georgian',
        iso_639_code: 'ka',
    },
    {
        name: 'German',
        iso_639_code: 'de',
    },
    {
        name: 'Greek',
        iso_639_code: 'el',
    },
    {
        name: 'Guarani',
        iso_639_code: 'gn',
    },
    {
        name: 'Gujarati',
        iso_639_code: 'gu',
    },
    {
        name: 'Haitian Creole',
        iso_639_code: 'ht',
    },
    {
        name: 'Hausa',
        iso_639_code: 'ha',
    },
    {
        name: 'Hawaiian',
        iso_639_code: 'haw',
    },
    {
        name: 'Hebrew',
        iso_639_code: 'iw',
    },
    {
        name: 'Hindi',
        iso_639_code: 'hi',
    },
    {
        name: 'Hmong',
        iso_639_code: 'hmn',
    },
    {
        name: 'Hungarian',
        iso_639_code: 'hu',
    },
    {
        name: 'Icelandic',
        iso_639_code: 'is',
    },
    {
        name: 'Igbo',
        iso_639_code: 'ig',
    },
    {
        name: 'Indonesian',
        iso_639_code: 'id',
    },
    {
        name: 'Irish',
        iso_639_code: 'ga',
    },
    {
        name: 'Italian',
        iso_639_code: 'it',
    },
    {
        name: 'Japanese',
        iso_639_code: 'ja',
    },
    {
        name: 'Javanese',
        iso_639_code: 'jw',
    },
    {
        name: 'Kannada',
        iso_639_code: 'kn',
    },
    {
        name: 'Kazakh',
        iso_639_code: 'kk',
    },
    {
        name: 'Khmer',
        iso_639_code: 'km',
    },
    {
        name: 'Korean',
        iso_639_code: 'ko',
    },
    {
        name: 'Kurdish',
        iso_639_code: 'ku',
    },
    {
        name: 'Kyrgyz',
        iso_639_code: 'ky',
    },
    {
        name: 'Lao',
        iso_639_code: 'lo',
    },
    {
        name: 'Latin',
        iso_639_code: 'la',
    },
    {
        name: 'Latvian',
        iso_639_code: 'lv',
    },
    {
        name: 'Lithuanian',
        iso_639_code: 'lt',
    },
    {
        name: 'Luxembourgish',
        iso_639_code: 'lb',
    },
    {
        name: 'Macedonian',
        iso_639_code: 'mk',
    },
    {
        name: 'Malagasy',
        iso_639_code: 'mg',
    },
    {
        name: 'Malay',
        iso_639_code: 'ms',
    },
    {
        name: 'Malayalam',
        iso_639_code: 'ml',
    },
    {
        name: 'Maltese',
        iso_639_code: 'mt',
    },
    {
        name: 'Maori',
        iso_639_code: 'mi',
    },
    {
        name: 'Marathi',
        iso_639_code: 'mr',
    },
    {
        name: 'Mongolian',
        iso_639_code: 'mn',
    },
    {
        name: 'Myanmar (Burmese)',
        iso_639_code: 'my',
    },
    {
        name: 'Nepali',
        iso_639_code: 'ne',
    },
    {
        name: 'Norwegian',
        iso_639_code: 'no',
    },
    {
        name: 'Nyanja (Chichewa)',
        iso_639_code: 'ny',
    },
    {
        name: 'Pashto',
        iso_639_code: 'ps',
    },
    {
        name: 'Persian',
        iso_639_code: 'fa',
    },
    {
        name: 'Polish',
        iso_639_code: 'pl',
    },
    {
        name: 'Portuguese (Portugal, Brazil)',
        iso_639_code: 'pt',
    },
    {
        name: 'Punjabi',
        iso_639_code: 'pa',
    },
    {
        name: 'Quechua',
        iso_639_code: 'qu',
    },
    {
        name: 'Romanian',
        iso_639_code: 'ro',
    },
    {
        name: 'Russian',
        iso_639_code: 'ru',
    },
    {
        name: 'Samoan',
        iso_639_code: 'sm',
    },
    {
        name: 'Scots Gaelic',
        iso_639_code: 'gd',
    },
    {
        name: 'Serbian',
        iso_639_code: 'sr',
    },
    {
        name: 'Sesotho',
        iso_639_code: 'st',
    },
    {
        name: 'Shona',
        iso_639_code: 'sn',
    },
    {
        name: 'Sindhi',
        iso_639_code: 'sd',
    },
    {
        name: 'Sinhala (Sinhalese)',
        iso_639_code: 'si',
    },
    {
        name: 'Slovak',
        iso_639_code: 'sk',
    },
    {
        name: 'Slovenian',
        iso_639_code: 'sl',
    },
    {
        name: 'Somali',
        iso_639_code: 'so',
    },
    {
        name: 'Spanish',
        iso_639_code: 'es',
    },
    {
        name: 'Sundanese',
        iso_639_code: 'su',
    },
    {
        name: 'Swahili',
        iso_639_code: 'sw',
    },
    {
        name: 'Swedish',
        iso_639_code: 'sv',
    },
    {
        name: 'Tagalog (Filipino)',
        iso_639_code: 'tl',
    },
    {
        name: 'Tajik',
        iso_639_code: 'tg',
    },
    {
        name: 'Tamil',
        iso_639_code: 'ta',
    },
    {
        name: 'Telugu',
        iso_639_code: 'te',
    },
    {
        name: 'Thai',
        iso_639_code: 'th',
    },
    {
        name: 'Turkish',
        iso_639_code: 'tr',
    },
    {
        name: 'Ukrainian',
        iso_639_code: 'uk',
    },
    {
        name: 'Urdu',
        iso_639_code: 'ur',
    },
    {
        name: 'Uzbek',
        iso_639_code: 'uz',
    },
    {
        name: 'Vietnamese',
        iso_639_code: 'vi',
    },
    {
        name: 'Welsh',
        iso_639_code: 'cy',
    },
    {
        name: 'Xhosa',
        iso_639_code: 'xh',
    },
    {
        name: 'Yiddish',
        iso_639_code: 'yi',
    },
    {
        name: 'Yoruba',
        iso_639_code: 'yo',
    },
    {
        name: 'Zulu',
        iso_639_code: 'zu',
    },
];
